<div
  class="docu-item"
  [class.allButton]="variant() !== 'image' && variant() !== 'file'"
  [class.desktop]="isDesktop()"
  [class.mobile]="isMobile()"
  [class.tablet]="isTablet()"
  (click)="onHeaderClick(); $event.stopPropagation()"
>
  <button class="docu-header body-bold">
    @if (svg_icon()) {
      <i nz-icon [nzType]="svg_icon() ?? ''" class="svg-icon"></i>
    }
    <span>
      <ng-content></ng-content>
    </span>

    @if (variant() === "text" && content().length > 0) {
      <i nz-icon [nzType]="'icons:edit'" class="svg-icon right-icon"></i>
    }
  </button>

  @if (variant() === "image") {
    <div class="hint detail">
      <div>Format: .jpg, .jpeg, .png</div>
      <div [class.red-text]="fileSizeError()">
        {{ i18n.langString("max_size") }}
      </div>
    </div>
  }

  @if (variant() === "file") {
    <div class="hint detail">
      <div>Format: .xlsx, .docx, .pptx, .pdf</div>
      <div [class.red-text]="fileSizeError()">
        {{ i18n.langString("max_size") }}
      </div>
    </div>
  }

  @if (variant() === "text" && content().length > 0) {
    <div class="text-content">
      <span>{{ content() }}</span>
    </div>
  }

  @if (variant() === "image") {
    <div class="image-content">
      <!-- Hidden inputs -->
      <input
        #imageInputUpload
        type="file"
        style="display: none"
        accept="image/png, image/jpeg, image/jpg"
        (change)="fileChanged($event, 'image')"
      />
      <input
        #imageInputCamera
        type="file"
        style="display: none"
        accept="image/png, image/jpg, image/jpeg"
        (change)="fileChanged($event, 'image')"
        capture="environment"
      />

      <!-- Thumbnails/Previews -->
      @for (item of content(); track $index) {
        <div class="preview-container">
          <img class="photo-preview" [src]="item.thumbnailLink" />
          <div
            class="close-icon"
            (click)="deleteAttachment(item); $event.stopPropagation()"
          >
            <i
              nz-icon
              nzType="icons:exit"
              class="svg-icon fillwhite mini-icon"
            ></i>
          </div>
        </div>
      }

      <!-- Upload progress -->
      @if (imageUploadProgress()) {
        <div>
          <div
            class="photo-preview"
            style="cursor: pointer"
            [ngClass]="{
              'progress-complete': imageUploadProgress()?.state === 'DONE',
            }"
          >
            <progress
              max="100"
              [value]="imageUploadProgress()?.progress"
            ></progress>
            <span>{{ imageUploadProgress()?.progress }} %</span>
          </div>
        </div>
      }

      <!-- Add button -->
      @if (content().length > 0) {
        <div
          class="photo-preview"
          (click)="onHeaderClick(); $event.stopPropagation()"
          style="cursor: pointer"
        >
          <i nz-icon nzType="icons:photoadd" class="svg-icon photoadd"></i>
        </div>
      }
    </div>
  }

  @if (variant() === "file") {
    <div class="file-content" [class.noMarginTop]="!(content().length > 0)">
      <!-- Hidden input -->
      <input
        #fileInput
        type="file"
        style="display: none"
        accept=".xlsx,.docx,.pptx,.pdf,.ppt,.xls"
        (change)="fileChanged($event, 'file')"
      />

      <!-- Previews -->
      @for (item of content(); track $index) {
        <div class="preview-container">
          <div
            class="close-icon"
            (click)="deleteAttachment(item); $event.stopPropagation()"
          >
            <i
              nz-icon
              nzType="icons:exit"
              class="svg-icon fillwhite mini-icon"
            ></i>
          </div>
          <div class="file-preview">
            <a [href]="item.storageLink" target="_blank">{{ item.name }}</a>
          </div>
        </div>
      }

      <!-- Upload progress -->
      @if (fileUploadProgress()) {
        <div
          class="file-progress"
          [ngClass]="{
            'progress-complete': fileUploadProgress()?.state === 'DONE',
          }"
        >
          <progress
            max="100"
            [value]="fileUploadProgress()?.progress"
          ></progress>
          <span>{{ fileUploadProgress()?.progress }} %</span>
        </div>
      }

      <!-- Add button -->
      <div
        class="file-preview add-file"
        (click)="addFile(); $event.stopPropagation()"
        style="cursor: pointer"
      >
        <i nz-icon nzType="icons:fileadd" class="svg-icon mini-icon"></i>
        @if (content().length > 0) {
          <span class="body-bold">{{
            i18n.langString("upload_another_file")
          }}</span>
        } @else {
          <span class="body-bold">{{ i18n.langString("upload_file") }}</span>
        }
      </div>
    </div>
  }
</div>

@if (takeOrUploadDialogOpen()) {
  <nz-modal
    [nzVisible]="true"
    [nzFooter]="null"
    (nzOnCancel)="takeOrUploadDialogOpen.set(false)"
    [nzTitle]="i18n.langString('take_or_upload_a_photo')"
    [nzCloseIcon]="'icons:exit'"
  >
    <div
      class="image-upload-selection"
      (click)="captureImage(); $event.stopPropagation()"
      style="cursor: pointer"
    >
      <i nz-icon nzType="icons:camera" class="svg-icon mini-icon"></i>
      <span class="body-bold">{{ i18n.langString("take_a_photo") }}</span>
    </div>
    <div
      class="image-upload-selection"
      (click)="uploadImage(); $event.stopPropagation()"
      style="cursor: pointer"
    >
      <i nz-icon nzType="icons:fileadd" class="svg-icon mini-icon"></i>
      <span class="body-bold">{{ i18n.langString("upload_a_photo") }}</span>
    </div>
  </nz-modal>
}
